<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<script setup lang="ts">
import type { PropType } from 'vue'

interface CAutocompleteProps {
  rounded?: string | number | boolean
  variant?:
    | 'filled'
    | 'outlined'
    | 'plain'
    | 'underlined'
    | 'solo'
    | 'solo-inverted'
    | 'solo-filled'
  items?: unknown[]
  itemTitle?: string
  itemValue?: string
  multiple?: boolean
  chips?: boolean
  clearable?: boolean
  closableChips?: boolean
}

const props = defineProps({
  color: {
    type: String,
    default: '',
  },
  rounded: {
    type: String as PropType<CAutocompleteProps['rounded']>,
    default: 'xl',
  },
  variant: {
    type: String as PropType<CAutocompleteProps['variant']>,
    default: 'outlined',
    validator: (value: string): boolean =>
      [
        'filled',
        'outlined',
        'plain',
        'underlined',
        'solo',
        'solo-inverted',
        'solo-filled',
      ].includes(value),
  },
  label: {
    type: String,
    default: 'Buscar',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  hiddenDetail: {
    type: Boolean,
    default: true,
  },
  singleLine: {
    type: Boolean,
    default: true,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  items: {
    type: Array as PropType<CAutocompleteProps['items']>,
    default: () => [],
  },
  itemTitle: {
    type: String as PropType<CAutocompleteProps['itemTitle']>,
    default: 'title',
  },
  itemValue: {
    type: String as PropType<CAutocompleteProps['itemValue']>,
    default: 'value',
  },
  multiple: {
    type: Boolean as PropType<CAutocompleteProps['multiple']>,
    default: false,
  },
  chips: {
    type: Boolean as PropType<CAutocompleteProps['chips']>,
    default: false,
  },
  clearable: {
    type: Boolean as PropType<CAutocompleteProps['clearable']>,
    default: false,
  },
  closableChips: {
    type: Boolean as PropType<CAutocompleteProps['closableChips']>,
    default: false,
  },
  noFilter: {
    type: Boolean,
    default: false,
  },
  autoSelectFirst: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits({
  changed: (event: unknown) => true,
})

const model = defineModel()
</script>

<template>
  <v-autocomplete
    :label="props.label"
    :variant="props.variant"
    :hide-details="props.hiddenDetail"
    :single-line="props.singleLine"
    :rounded="props.rounded"
    :loading="props.loading"
    :disabled="props.disabled"
    :readonly="props.readonly"
    :items="props.items"
    :item-title="props.itemTitle"
    :item-value="props.itemValue"
    :multiple="props.multiple"
    :chips="props.chips"
    :clearable="props.clearable"
    :closable-chips="props.closableChips"
    :color="props.color"
    :no-filter="props.noFilter"
    :auto-select-first="props.autoSelectFirst"
    density="comfortable"
    v-model="model"
    @update:model-value="emits('changed', $event)"
  ></v-autocomplete>
</template>
